module.exports = __webpack_public_path__ + "img/C04TechAidTent_ua.eab18640.webp";